import DOMPurify from 'dompurify';

// v-safe-html: reemplazo de v-html que sanitiza con DOMPurify antes de pintar.
// Deja el HTML de formato (p, strong, ul, a, tablas…) y quita scripts, handlers
// (onerror, onclick…) y URLs javascript:. Usar siempre que el contenido venga del
// usuario, de la API o de la IA.

const SANITIZE_CONFIG = { ADD_ATTR: ['target'] };

// Los links que abren en otra pestaña no deben poder tocar window.opener.
DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  if (node.tagName === 'A' && node.getAttribute('target') === '_blank') {
    node.setAttribute('rel', 'noopener noreferrer');
  }
});

export function sanitizeHtml(value) {
  if (value === null || value === undefined) return '';
  return DOMPurify.sanitize(String(value), SANITIZE_CONFIG);
}

function render(el, { value, oldValue }) {
  if (el.__safeHtmlRendered && value === oldValue) return;
  el.innerHTML = sanitizeHtml(value);
  el.__safeHtmlRendered = true;
}

export default {
  mounted: render,
  updated: render,
};
